<template>
  <div @click="showField" :class="getClasses()">
    <div class="field-header">
      <div class="field-label" v-show="showLabel">{{ customField.label }}</div>
      <div class="last-updated" v-if="customField.field_type == 'wysiwyg' && customField.updated_at && updatedOnTop == true">
        Last updated {{ customField.updated_at | moment('MMM D HH:mm a') }}
      </div>
    </div>
    <div class="field-wrap" v-if="customField.field_type == 'priority'">
        <div class="priority-rating" @click="setPriority(customField)">
          <vue-star-rate
            :rateRange="customField.value ? Number(customField.value) : 0"
            :maxIcon="5"
            :iconHeight="17"
            :iconWidth="17"
            :hasCounter="false"
            :key="'del-priority-'+Math.random()+deliverable.id"
            iconColor="var(--wf-primary)"
            iconColorHover="var(--wf-primary)"
            iconShape="circle"
          ></vue-star-rate>
        </div>
    </div>
    <div class="field-wrap" v-if="customField.field_type == 'wysiwyg'">
        <ckeditor
          :readOnly="!userAbilities.editMediaCall || deliverable.permissions.viewOnly"
          editorUrl="/js/ckeditor/ckeditor.js"
          ref="customInput"
          v-model="customField.value"
          :id="'custom-field-'+_uid"
          :config="editorConfig"
          @input="changed=true"
          @blur="checkChangedFieldValue(customField)"
          @ready="changed=false"
        ></ckeditor>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'textarea'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"  :title="customField.value"
        v-b-tooltip.hover
        style="white-space: pre-line;"
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="field-value">
        <textarea
          :rows="rows"
          ref="customInput"
          class="form-control custom-inputs"
          v-show="editing"
          v-click-outside="outside"
          @change="updateFieldValue(customField)"
          @blur="editing = false"
          v-model="customField.value"
        />
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'website'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-if="!customField.value"
        v-show="!editing"
        :title="customField.value"
        v-b-tooltip.hover
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="resource-box" 
        v-if="customField.value" 
        v-show="!editing">
        <div class="media">
          <img class="link-type-icon" 
          style="margin-right: 3px;" 
          :src="require(`@/csmworkflow/img/link-url.svg`)" 
          draggable="false" />
          <div class="media-body">
            <div class="resource-box__url">
              <a 
              :href="customField.value" 
              target="_blank"
              :id="customField.field_type"
              >{{customField.value}}</a>
            </div>
              <a
              v-b-tooltip.hover
              title="Edit website"
              class="edit-resource-btn"
              href="#"
              @click="editing = true"
              >
              <i class="fas fa-edit"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="field-value" v-show="editing">
        <b-form-input type="url"           
          ref="customInput"
          class="form-control custom-inputs"
          v-click-outside="outside"
          @change="formatWebsiteUrl()"
          v-model="customField.value"
          :formatter="Format.website"
          lazy-formatter
        />
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'select'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"
      >{{ customField.value || 'Click to set...' }}</span>
      <div class="custom-field">
        <multiselect
          ref="customInput"
          v-click-outside="outside"
          v-model="customField.value"
          :show-labels="false"
          :options="getOptions"
          :multiple="false"
          v-show="editing"
          @close="editing=false"
          @input="updateFieldValue(customField); editing = false"
        ></multiselect>
      </div>
    </div>

    <div class="field-wrap no-icon" v-if="customField.field_type == 'status'">
      <span
        v-if="customField.value"
        class="exclude-outside-click field-value status-field-value"
        :style="{ backgroundColor: parseValue(customField.value).color || customField.value.color }"

      >{{ parseValue(customField.value).name || customField.value.name }}</span>
      <span
        v-if="!customField.value"
        class="exclude-outside-click field-value"
        v-show="!editing"
      >Click to set...</span>
      <div class="custom-field status-field">
        <multiselect
          ref="customInput"
          :searchable="false"
          v-show="editing"
          v-click-outside="outside"
          v-model="customField.value"
          :options="getOptions"
          @close="editing=false"
          @input="updateFieldValue(customField);"
          @select="editing=false"
          :custom-label="customLabel"
          :show-labels="false">
          <template slot="option" slot-scope="props">
            <div :style="{ color: 'var(--wf-secondary)', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">{{ props.option.name }}</div>
          </template>
        </multiselect>
      </div>
    </div>

    <div class="field-wrap no-icon custom-field-users-wrapper" 
      v-if="customField.field_type == 'users' && !isMultipleField">
      <div class="field-value exclude-outside-click">
        <span class="info-bubbles">
          <span
            v-if="!customField.value"
            v-b-tooltip.hover
            title="Click to set..."
            class="exclude-outside-click field-value"
            style="display: inline-block"
          >Click to set...</span>
          <span
            v-if="customField.value && selectedUser"
            v-b-tooltip.hover
            :title="selectedUser ? (selectedUser.name) :  'Click to set...'"
            class="exclude-outside-click field-value"
            style="display: inline-block"
            :class="{ 'initials badge badge-primary': customField.value }"
          > {{  (selectedUser.name) | textInitials }} </span>
        </span>
        <div class="add-multiselect-group" 
          :class="[customField.value ? 'l-65' : 'l-145']">
          <plus-button v-if="customField.value" />
          <div class="custom-field user-field custom-multiselect" v-show="editing">
            <multiselect
              ref="customInput"
              v-click-outside="outside"
              v-model="selectedUser"
              :options="allActiveUsers"
              :show-labels="false"
              :multiple="isMultipleField"
              open-direction="bottom"
              label="name"
              track-by="id"
              @close="editing=false"
              @input="userSelect"
            ></multiselect>
          </div>
        </div>
      </div>
    </div>

    <div class="field-wrap no-icon custom-field-users-wrapper" 
      v-if="customField.field_type == 'users' && isMultipleField">
      <div class="field-value exclude-outside-click">
        <div class="custom-field user-field custom-multiselect" v-show="editing">
            <multiselect
              ref="customInput"
              v-click-outside="outside"
              v-model="selectedUsers"
              :options="allActiveUsers"
              :show-labels="false"
              :close-on-select="false" 
              :multiple="isMultipleField"
              open-direction="bottom"
              label="name"
              track-by="id"
              @close="editing=false"
              @input="multipleUsersSelect"
            ></multiselect>
        </div>
        <span
            v-if="selectedUsers.length == 0"
            v-b-tooltip.hover
            title="Click to set..."
            class="exclude-outside-click field-value"
            style="display: inline-block"
          >Click to set...</span>
        <span class="info-bubbles" 
          v-if="selectedUsers.length > 0"
          v-for="(sUser, index) in selectedUsers"
          :key="`${customField.field_key}-${index}`">
          <span
            v-if="sUser.name"
            v-b-tooltip.hover
            :title="sUser && sUser.name ? sUser.name : 'Click to set...'"
            class="exclude-outside-click field-value initials badge badge-primary"
            style="display: inline-block"
          > {{  (sUser.name) | textInitials }} </span>
          <span
            v-else
            v-b-tooltip.hover
            title="Click to set..."
            class="exclude-outside-click field-value"
            style="display: inline-block"
          > Click to set...</span>
        </span>
        <div class="add-multiselect-group" >
          <plus-button v-if="selectedUsers.length > 0" />
        </div>
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'datepicker'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"
      >
          <span v-if="customField.value" 
            >{{ customField.value | moment("DD MMM, YYYY") }}</span>
          <span v-else>No Date</span>
      </span>
      <div class="custom-field">
        <vuejs-datepicker
          ref="customDatepicker"
          :format="customDateFormat"
          name="due_date"
          v-show="editing"
          v-model="customField.value"
          v-click-outside="outside"
          input-class="custom-datepicker form-control"
          :typeable="true"
          :inline="true"
          @input="updateFieldValue(customField)"
          @closed="dateSelected=true"
          @selected="dateSelected=true"
        >
          <div slot="beforeCalendarHeader" class="calender-header">
            <b-button class="remove-dl-btn" variant="text" 
            @click="resetDeadline">Reset Date</b-button>
            <b-button class="today-btn" variant="text" 
            @click="onToday">Today</b-button>
          </div>
        </vuejs-datepicker>
      </div>
    </div>

    <div class="field-wrap" v-if="customField.field_type == 'datetimepicker'">
      <div class="custom-field-date-time-picker-wrapper">
        <fieldset class="date-time">
          <div class="date">
            <span class="vdp-datepicker exclude-outside-click text-hover-bg"
                @click="editing = true" 
                @keyup="onWrapperKeyUp" 
                tabindex="0" >
              <span class="exclude-outside-click vdp-datepicker__placeholder" 
                v-if="postDate"
                v-html="displayPostDate(postDate)"></span>
              <span class="not-set exclude-outside-click vdp-datepicker__placeholder" 
                v-else>No Date</span>
            </span>

            <div 
              v-show="editing" 
              class="custom-field date-pick-field" 
              @keyup.stop="onKeyUp" >
              <DateTimePicker 
                input-class="form-control" 
                :name="customField.field_key" 
                placeholder="YYYY-MM-DD"
                v-model="postDate"
                v-click-outside="outside"
                :format="'yyyy-MM-dd'" 
                :inline="true"
                :typeable="true"
                :autofocus="true"
                calendar-class="cf-datetime-calendar"
                ref="refDate"
                tabindex="0"
                @closed="dateTimeUpdated"
                @input="dateTimeUpdated"
                @selected="setDefaultTime"
                >
                <div slot="beforeCalendarHeader" class="calender-header">
                  <b-button class="remove-dl-btn" variant="text" 
                  @click="resetDeadline">Reset Date/Time</b-button>
                  <b-button class="today-btn" variant="text" 
                  @click="onToday">Today</b-button>
                </div>
                <div slot="calendarFooter" class="calender-footer">
                  <div class="time-wrapper">
                    <input 
                      type="time" 
                      :id="`cf_time_${customField.field_key}`" 
                      name="publish_time" 
                      v-model="postTime"
                      ref="refTime" tabindex="1" 
                      @keyup.escape.stop="onKeyUp" 
                      @blur="dateTimeUpdated" 
                      />
                  </div>
                  <b-button class="today-btn" variant="text" 
                  @click.stop="onDone" tabindex="2">Done</b-button>
                </div>
              </DateTimePicker>
            </div>
          </div>
          <div class="time">
            <input 
              v-if="postTime !== null"
              type="time" 
              class="form-control cf-input"
              :id="`cf_time_${customField.field_key}`" 
              name="publish_time" 
              step="60"
              v-model="postTime"
              @blur="dateTimeUpdated" />
              <span v-else 
              class="time__placeholder">No Time</span>
          </div>
        </fieldset>
      </div>
    </div>

    
    <div class="field-wrap" v-if="customField.field_type == 'currency'">
        <div class="currency-field">
            <span 
              class="exclude-outside-click edit-d-title" 
              v-show="!editing">{{ customField.value ? formatPrice(customField.value) : '0.00' }}</span>
            <div class="input-group" v-show="editing" v-click-outside="outside">
                <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                </div>
                <input 
                  class="form-control" 
                  v-model="customField.value" 
                  :placeholder="customField.label" 
                  ref="customInput" 
                  @keyup.enter="editing = false" 
                  @change="updateFieldValue(customField)" 
                  @blur="editing = false" />
            </div>
        </div>
    </div>

    <span v-if="customField.field_type == 'file'">
      <input type="file" />
    </span>

    <span v-if="customField.field_type == 'radio'">
      <label
        class="ml-2"
        v-for="(radioValue, index) in parseValue(customField.value_set)"
        :key="'radio'+index"
      >
        <input
          @change="updateFieldValue(customField)"
          type="radio"
          :value="radioValue"
          v-model="customField.value"
        />
        {{ radioValue }}
      </label>
    </span>

    <div class="field-wrap" 
      v-if="customField.field_type == 'switch'">
      <div class="field-value custom-field-switcher-wrapper">
        <div class="switch-toggle">
          <template v-for="(radioValue, index) in parseValue(customField.value_set)">
            <input class="no-focus-visible-outline"  
            type="radio" 
            :id="`cfsl_${customField.field_key}_${index}`"
            :name="customField.field_key"
            :value="JSON.stringify(radioValue)"
            v-model="customField.value"
            :checked="defaultCheckedValue == radioValue.slug"
            @change="updateFieldValue(customField)"
            />
            <label class="no-focus-visible-outline" 
            :for="`cfsl_${customField.field_key}_${index}`" 
            v-b-tooltip.hover 
            :title="radioValue.name">{{radioValue.name}}</label>
          </template>
          <a class="btn no-focus-visible-outline"></a>
        </div>
      </div>
    </div>

    <!-- <div class="field-wrap" v-if="customField.field_type == 'language_picker'">
      <span
        class="exclude-outside-click field-value text-hover-bg"
        v-show="!editing"
      >{{ selectedLanguageName }}</span>
      <div class="custom-field">
        <multiselect
          ref="customInput"
          v-click-outside="outside"
          v-model="customField.value"
          :show-labels="false"
          :options="getOptions"
          :multiple="false"
          v-show="editing"
          @close="editing=false"
          label="name"
          track-by="slug"
          @input="languageSelect"
        ></multiselect>
      </div>
    </div> -->

    <div class="last-updated last-updated-below" v-if="customField.field_type == 'wysiwyg' && customField.updated_at && updatedOnTop == false">
      Last updated {{ customField.updated_at | moment('MMM D HH:mm a') }}
    </div>
  </div>
</template>

<script>
import vueStarRate from "vue-js-star-rating";
import Datepicker from "vuejs-datepicker";
import { mapActions, mapGetters } from "vuex";
import Format from "../../utility/Format";
import '../vue-datepicker/Datepicker.css';
import DateTimePicker from '../vue-datepicker/Datepicker.js';

export default {
  name: "CustomFields",
  props: {
    customField:Object,
    users: Array,
    showLabel: {
      type:Boolean,
      default: true
    },
    updatedOnTop: {
      type:Boolean,
      default: true
    },
    rows: {
      type:Number,
      default: 10
    },
    deliverable: Object,
    namespace:String
  },
  data() {
    return {
      exclamationCircle: '',
      editing: false,
      Format,
      dateSelected: false,
      postDate: "",
      postTime: "",
      dateFormatUI: "YYYY-MM-DD HH:mm",
      dateFormatDB: "YYYY-MM-DD HH:mm:ss",
      changed:false,
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },                                        
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      },
      selectedUsers: [],
    };
  },
  computed: {
    ...mapGetters([
      "allActiveUsers",
      "userAbilities"
    ]),
    _: function() {
      return _;
    },
    selectedUser: {
      get() {
        if (this.customField.value) {
          return this.allActiveUsers.find(user => user.id == this.customField.value);
        }
        return null;
      },
      set(newValue) {
        if (newValue) {
          this.customField.userName = newValue.name;
          this.customField.value = newValue.id;
        } else {
          this.customField.value = null;
        }
      }
    },
    isMultipleField() {
      let isMultiple = false;
      const fieldExists = this.deliverable.templateCustomFields.find(field => field.field_key === this.customField.field_key);

      if (fieldExists) {
        isMultiple = fieldExists.is_multiple ? true : false;
      }
      return isMultiple;
    },
    defaultCheckedValue() {
      if (!this.customField.value) {
        const templateField = this.deliverable.templateCustomFields.find(field => field.field_key === this.customField.field_key);
        if (templateField && templateField.properties_set) {
          const parsed = this.parseValue(templateField.properties_set);
          if (parsed == false) {
            return false;
          } else {
            return parsed.default.slug;
          }
        } else {
          return false;
        }
      } else {
        const parsed = this.parseValue(this.customField.value);
        if (parsed == false) {
          return false;
        } else {
          return parsed.slug;
        }
      }
    },
    /*
    selectedLanguageName() {
      if (this.customField) {
        if (this.customField.value) {
          if (this.customField.value_set) {
            let parsed = this.parseValue(this.customField.value_set);
            if (parsed == false) {
              return [];
            } else {
              const language = parsed.find(lang => lang.slug === this.customField.value);
              return language ? language.name : "Language not found";
            }
          }
        } else {
          return 'Click to set...';
        }
      }
    },
    */
    getOptions() {
      if (this.customField) {
        if (this.customField.value_set) {
          let parsed = this.parseValue(this.customField.value_set);
          if (parsed == false) {
            return [];  // if we don't check for false... it throws up errors
          } else {
            // build value and text
            return parsed;
          }
        }
      }
      return [];
    },
    postDateFormatted(){
      return this.$moment(this.postDate).format("YYYY-MM-DD");
    },
    dateIsSet(){
        return true;
    },
    timeIsSet(){
        return true;
    },
  },
  components: {
    "vuejs-datepicker": Datepicker,
    DateTimePicker,
    vueStarRate
  },
  methods: {
  	...mapActions({
  	  updateFieldValue (dispatch, payload) {
  	    return dispatch(this.namespace + 'updateFieldValue', payload)
  	  },
  	  updateMultipleUsersFieldValue (dispatch, payload) {
  	    return dispatch(this.namespace + 'updateMultipleUsersFieldValue', payload)
  	  },
  	}),
    userSelect(value) {
      // set value to save
      let val = value ? value.id : null;
      let payload = {
        ...this.customField,
        value: val
      };
      this.updateFieldValue(payload);
      this.editing = false;
    },
    multipleUsersSelect(userArray) {
      let val = [];
      userArray.forEach(item => {
        val.push(item.id);
      });
      this.customField.value = val; // to hide click to set span
      let payload = {
        ...this.customField,
        deliverableId: this.deliverable.deliverableId,
        value: val
      };
      this.updateMultipleUsersFieldValue(payload);
      this.editing = false;
    },
    /*
    languageSelect(value) {
      this.customField.value = value.slug;
      this.updateFieldValue(this.customField);
      this.editing = false;
    },
    */
    formatWebsiteUrl() {
      let payload = {
        ...this.customField,
        deliverableId: this.deliverable.deliverableId,
        value: Format.website(this.customField.value),
      };
      this.updateFieldValue(payload); 
      this.editing = false;
    },
    onWrapperKeyUp(e) {
			if (e.keyCode === 13) {
			  this.editing = true;
			}
		},
    onToday() {
      this.postDate = this.$moment().format("YYYY-MM-DD");
      this.postTime = "00:00"
      this.editing = false;
      this.dateSelected = true;
      this.clickSaveDate();
    },
    resetDeadline() {
      this.postDate = null;
      this.postTime = null;
      this.editing = false;
      this.dateSelected = true;
      this.clickSaveDate();
    },
    onDone() {
			this.editing = false;
		  this.dateSelected = true;
		  this.clickSaveDate();
		},
    onKeyUp(e) {
      if (e.keyCode === 27) {
        this.editing = false;
        this.dateSelected = false;
      }
      if (e.keyCode === 13) {
        this.editing = false;
        this.dateSelected = true;
        this.clickSaveDate();
        e.stopPropagation();
      }
    },
    displayPostDate(date) {
      let today = this.$moment();
      if (today.isSame(this.postDate, 'day')) {
        return "Today";
      }
      return this.$moment(date).format("ddd, MMM D YYYY");
    },
    setDefaultTime() {
      // when a date is selected, set time to midnight by default
      // so when clicking on date & only hour will set post time
      if (this.postDate && !this.postTime) {
        this.postTime = "00:00"
      }
    },
    clickSaveDate() {
      if (this.dateIsSet && this.timeIsSet) {
        this.dispatchPublishDate();
      }
    },
    dateTimeUpdated(){
      if(this.dateIsSet && this.timeIsSet){
        this.dispatchPublishDate();
      }
      else if(this.dateIsSet && !this.timeIsSet){
        let currentDateTime = this.$moment().startOf('minute');
        let nine = this.$moment("09:00", "HH:mm");
        let midnight = this.$moment().startOf('day');
        let selectedDate = this.$moment(this.postDate).startOf('day');
        if(midnight.isSame(selectedDate)){
          if(currentDateTime.isBetween(midnight, nine)){
            this.postTime = "00:00"
            this.dispatchPublishDate();
          } else {
            let remainder = 15 - (currentDateTime.minute() % 15);
            this.postTime = this.$moment(currentDateTime).add(remainder, "minutes").add(2, "hours").format("HH:mm");
            this.dispatchPublishDate();
          }
        } else {
          this.postTime = "00:00"
          this.dispatchPublishDate();
        }
      } 
    },
    dispatchPublishDate(){
      let that = this;
      if (that.postDate != null &&
        (that.postTime == "" || that.postTime == null)) {
        that.postTime = "00:00";
      }
      let selection = this.postDateFormatted+" "+this.postTime;
      let utc = this.$moment(selection).utc().format(this.dateFormatDB);
      if (that.postDate == null) {
      		utc = null;
      }
      if(utc == "Invalid date"){
        return;
      }
      this.customField.value = utc;
      this.updateFieldValue(this.customField);
    },
    formatPrice(value) {
    		const rangeArray = value.split(/(\-|to)/g);

        if (rangeArray.length > 1) {
          for (let i in rangeArray) {
            rangeArray[i] = rangeArray[i].replaceAll(/\$/g, "");
            rangeArray[i] = rangeArray[i].trim();
          }

          let val1 = (rangeArray[0]/1).toFixed(2);
          let val2 = typeof rangeArray[1] == 'number' ? (rangeArray[1]/1).toFixed(2) : (rangeArray[2]/1).toFixed(2);

          if (isNaN(val1) || isNaN(val2)) {
          	return value;
          }

          return "$" +  val1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - $" + val2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          let valString = value.replaceAll(/\$/g, "");
          valString = valString.trim()
          let val = (valString/1).toFixed(2);

          if (isNaN(val)) return value;

          return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
    },
    userCanEditProject() {
      const userId = localStorage.getItem("userId");
      const project = this.deliverable;

			if (this.userAbilities.accessAllProjects) {
				return true;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}
			return (this.userAbilities.editProject && isManager);
    },
    setPriority(customField) {
      let priority = $('.priority-rating .vue-star-rate ul.list li.active').length;
      customField.value = priority;
      this.updateFieldValue(customField);
      this.$emit('priority-updated', priority);
    },
    customLabel({ name }) {
      return name
    },
    checkChangedFieldValue(customField) {
      if (this.changed) {
        this.changed = false;
        this.updateFieldValue(customField);
      }
    },
    getClasses() {
      let cl = "field-container";
        if (this.customField) {
          if(this.customField.field_key) {
            return " field-container--" + this.customField.field_key;
          }
        }
        return cl;
    },
    customDateFormat(date) {
      return this.$moment(date).format("DD MMM, YYYY");
    },
    parseValue(str) {
      try {
          return JSON.parse(str);
      } catch (e) {
          return false;
      }
    },
    showField() {
      if(!this.userCanEditProject()) return;
      if(this.editing && !this.dateSelected) return;
      this.editing = true;
      this.$nextTick(() => {
        if (typeof this.$refs.customInput != "undefined") {
          if(this.customField.field_type == 'wysiwyg') {
          } else {
            if (typeof this.$refs.customInput.quill != "undefined") {
              this.$refs.customInput.quill.focus();
            } else if (typeof this.$refs.customInput.$el != "undefined") {
              this.$refs.customInput.$el.focus();
            } else {
              this.$refs.customInput.focus();
            }
          }
        } else if(typeof this.$refs.customDatepicker != "undefined") {
          if(!this.dateSelected) {
            this.$refs.customDatepicker.showCalendar()
            this.$refs.customDatepicker.$el.querySelector('input').focus()
          } else if(this.dateSelected) {
            this.dateSelected = false
            this.editing = false
          }

        }
      });
    },
    getStatuses(dataJson) {
      let data = this.parseValue(dataJson),
        options = [];
      data.forEach(status => {
        options.push(status.name)
      });
      return options;
    },
    outside() {
      this.editing = false
      this.dateSelected = false
    },
  },
  mounted() {
    let self = this;
    window.addEventListener("keyup", function(e) {
      if (e.keyCode === 27) {
        self.editing = false
        self.dateSelected = false
      }
    });
  },
  created() {
    if (this.customField) {
      if (this.customField.value && this.customField.field_type == 'datetimepicker') {
        let localPublishDate = this.$moment.utc(this.customField.value).local().format(this.dateFormatUI);
        if (localPublishDate != "Invalid date") {
          let localPublishArray = localPublishDate.split(" ");
          this.postDate = this.$moment(localPublishArray[0]).toDate();
          this.postTime = localPublishArray[1];
        }
      }
      if (this.customField.field_type == 'users') {
        const usersFields = this.deliverable.customFields.filter(field => field.field_key === this.customField.field_key);
        const alreadySelectedUsers = [];
        usersFields.forEach(item => {
          if (item.value) {
            alreadySelectedUsers.push(this.allActiveUsers.find(user => user.id == item.value));
          }
        });
        this.selectedUsers = alreadySelectedUsers;
        if (alreadySelectedUsers.length > 0) {
          this.customField.value = alreadySelectedUsers;
        }
      }
    }
  },
};
</script>

<style lang="scss">

</style>